import React, { useState, useEffect } from 'react'
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form'
import { BodyParams, ErrorBoxComponent, FieldProps, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { codeTextField, companyIDField, datePickerField, idField, imeiField, machineTypeIDField, numberField, requiredTextField, textField } from '../common/fields'

export interface MachineFormData extends FormDataBase {
  id?: string
  name: string
  companyID: string
  imei: string
  serialNumber: string
  internalNumber: string
  manufactureDate: Date
  machineTypeID: string
  udtReviewDate: Date
  udtExpiration: Date
  inspectionDate: Date
  inspectionExpirationDate: Date
  warrantyExpirationDate: Date
}

export interface MachineFormParams extends BodyParams<MachineFormData> {
  onSubmit: onSubmit<MachineFormData>
}

export const SuperAdminMachineBody = (params: BodyParams<MachineFormData>) => {
  const fieldProps: FieldProps<MachineFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {name(fieldProps)}
    {machineTypeID(fieldProps)}
    {companyID(fieldProps)}
    {imei(fieldProps)}
    {serialNumber(fieldProps)}
    {internalNumber(fieldProps)}
    {manufactureDate(fieldProps)}
    {udtReviewDate(fieldProps)}
    {udtExpiration(fieldProps)}
    {inspectionDate(fieldProps)}
    {inspectionExpirationDate(fieldProps)}
    {warrantyExpirationDate(fieldProps)}
    {id(fieldProps)}
  </>
}

export const SuperAdminEditMachineForm = (params: MachineFormParams) => {
  const formHandler: SubmitHandler<MachineFormData> = (data) => {
    params.onSubmit(data)
  }
  return <FormWrapper<MachineFormData> className='main-form main-form-two-col' {...params} formName='machine' onSubmit={formHandler}>
    <SuperAdminMachineBody {...params} />
  </FormWrapper>
}

export const SuperAdminInsertMachineForm = (params: MachineFormParams) => {
  const formHandler: SubmitHandler<MachineFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<MachineFormData> className='main-form main-form-two-col' {...params} formName='machine' onSubmit={formHandler}>
    <SuperAdminMachineBody {...params} />
  </FormWrapper>
}

export const id = (props: FieldProps<MachineFormData>) => idField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'id', formName: props.formName || 'machine' })
export const name = (props: FieldProps<MachineFormData>) => requiredTextField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'name', formName: props.formName || 'machine' })
export const companyID = (props: FieldProps<MachineFormData>) => companyIDField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'companyId', formName: props.formName || 'machine' })
export const imei = (props: FieldProps<MachineFormData>) => imeiField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'imei', formName: props.formName || 'machine' })
export const serialNumber = (props: FieldProps<MachineFormData>) => codeTextField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'serialNumber', formName: props.formName || 'machine' })
export const internalNumber = (props: FieldProps<MachineFormData>) => textField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'internalNumber', formName: props.formName || 'machine' })
export const manufactureDate = (props: FieldProps<MachineFormData>) => numberField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'manufactureDate', formName: props.formName || 'machine' })
export const machineTypeID = (props: FieldProps<MachineFormData>) => machineTypeIDField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'machineTypeId', formName: props.formName || 'machine' })
export const udtReviewDate = (props: FieldProps<MachineFormData>) => datePickerField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'udtReviewDate', formName: props.formName || 'machine' })
export const udtExpiration = (props: FieldProps<MachineFormData>) => datePickerField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'udtExpirationDate', formName: props.formName || 'machine' })
export const inspectionDate = (props: FieldProps<MachineFormData>) => datePickerField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'inspectionDate', formName: props.formName || 'machine' })
export const inspectionExpirationDate = (props: FieldProps<MachineFormData>) => datePickerField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'inspectionExpirationDate', formName: props.formName || 'machine' })
export const warrantyExpirationDate = (props: FieldProps<MachineFormData>) => datePickerField<MachineFormData>()({ ...props, fieldName: props.fieldName || 'warrantyExpirationDate', formName: props.formName || 'machine' })